module.exports = __webpack_public_path__ + "img/therapy.d677023f.png";